import { createContext, useContext } from "react";

export const LandingModalContext = createContext(null);

export function useLandingModals() {
  const ctx = useContext(LandingModalContext);
  if (!ctx) {
    throw new Error("useLandingModals must be used within LandingLayout");
  }
  return ctx;
}
